import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import AppStoreModal from "../components/download/AppStoreModal";

const AppDownloadContext = createContext(null);

export function AppDownloadProvider({ children }) {
  const [appModalOpen, setAppModalOpen] = useState(false);

  const openAppModal = useCallback(() => setAppModalOpen(true), []);
  const closeAppModal = useCallback(() => setAppModalOpen(false), []);

  const value = useMemo(
    () => ({ openAppModal, closeAppModal }),
    [openAppModal, closeAppModal]
  );

  return (
    <AppDownloadContext.Provider value={value}>
      {children}
      <AppStoreModal isOpen={appModalOpen} onClose={closeAppModal} />
    </AppDownloadContext.Provider>
  );
}

export function useAppDownload() {
  const ctx = useContext(AppDownloadContext);
  if (!ctx) {
    throw new Error("useAppDownload must be used within AppDownloadProvider");
  }
  return ctx;
}
